import {cva, cx} from "@panda/css";

import {IButtonSizePrimary} from "@pg-design/button-module";
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

interface IProps {
    // the size of the button that will take the slot - without it the height comes from the className
    size?: IButtonSizePrimary;
    fullWidth?: boolean;
    className?: string;
}

// An empty slot as tall as the reservation button it stands in for, hidden from assistive technologies
export const ReservationCtaPlaceholder = (props: IProps) => {
    const {size, fullWidth, className} = props;

    return <span aria-hidden className={cx(placeholderStyle({size, fullWidth}), className)} data-testid={RP_RESERVATION_TEST_IDS.CTA_PLACEHOLDER} />;
};

const placeholderStyle = cva({
    base: {
        display: "block"
    },
    variants: {
        // the heights of the @pg-design/button-module sizes
        size: {
            "x-small": {height: "calc(5 * var(--globals-baseUnit))"},
            small: {height: "calc(6 * var(--globals-baseUnit))"},
            medium: {height: "calc(7 * var(--globals-baseUnit))"},
            big: {height: "calc(9 * var(--globals-baseUnit))"}
        },
        fullWidth: {
            true: {width: "100%"}
        }
    }
});
import {cva, cx} from "@panda/css";

import {IButtonSizePrimary} from "@pg-design/button-module";
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

interface IProps {
    // the size of the button that will take the slot - without it the height comes from the className
    size?: IButtonSizePrimary;
    fullWidth?: boolean;
    className?: string;
}

// An empty slot as tall as the reservation button it stands in for, hidden from assistive technologies
export const ReservationCtaPlaceholder = (props: IProps) => {
    const {size, fullWidth, className} = props;

    return <span aria-hidden className={cx(placeholderStyle({size, fullWidth}), className)} data-testid={RP_RESERVATION_TEST_IDS.CTA_PLACEHOLDER} />;
};

const placeholderStyle = cva({
    base: {
        display: "block"
    },
    variants: {
        // the heights of the @pg-design/button-module sizes
        size: {
            "x-small": {height: "calc(5 * var(--globals-baseUnit))"},
            small: {height: "calc(6 * var(--globals-baseUnit))"},
            medium: {height: "calc(7 * var(--globals-baseUnit))"},
            big: {height: "calc(9 * var(--globals-baseUnit))"}
        },
        fullWidth: {
            true: {width: "100%"}
        }
    }
});
